import { zs } from './zod';

/** A calendar date, YYYY-MM-DD. */
export const isoDateField = zs.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Invalid date');
